// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f4482871","732":"ed3e4b0f","977":"94890fc6"}[chunkId] + ".chunk.js";
};